import Hero from "../../frontend/components/Hero";
import CalculatorsImag1 from "../../assets/images/HowMuchCanIBorrowCalculator.jpg";
import HowMuchCanIBorrowCalculator from "../../frontend/components/calculators/HowMuchCanIBorrowCalculator";

const HowMuchCanIBorrowPage = () => {
  return (
    <div>
      <Hero
        title="How Much Can I Borrow"
        subtitle=""
        backgroundImage={CalculatorsImag1}
      />
      <HowMuchCanIBorrowCalculator />
      {/* <div className="landing-page">
            </div> */}
    </div>
  );
};

export default HowMuchCanIBorrowPage;
